export const isValidHighDemandFlagValue = (valueFromFwF: unknown): boolean => {
  if (typeof valueFromFwF !== 'object' || valueFromFwF == null) return false;

  if (
    !('availability_preparation_time_adjustment_enabled' in valueFromFwF) ||
    typeof valueFromFwF.availability_preparation_time_adjustment_enabled !== 'boolean'
  )
    return false;

  if (
    !('availability_preparation_time_stepper_enabled' in valueFromFwF) ||
    typeof valueFromFwF.availability_preparation_time_stepper_enabled !== 'boolean'
  )
    return false;

  if (
    !('allowed_availability_prep_times' in valueFromFwF) ||
    !Array.isArray(valueFromFwF.allowed_availability_prep_times) ||
    valueFromFwF.allowed_availability_prep_times.length < 1 ||
    !valueFromFwF.allowed_availability_prep_times.every((v) => typeof v === 'number') ||
    !valueFromFwF.allowed_availability_prep_times.every((v) => v > 0)
  )
    return false;

  if (
    !('busy_mode_durations' in valueFromFwF) ||
    !Array.isArray(valueFromFwF.busy_mode_durations) ||
    valueFromFwF.busy_mode_durations.length < 1 ||
    !valueFromFwF.busy_mode_durations.every((v) => typeof v === 'number') ||
    !valueFromFwF.busy_mode_durations.every((v) => v > 0)
  )
    return false;

  if (
    !('high_demand_mode_duration_minutes' in valueFromFwF) ||
    typeof valueFromFwF.high_demand_mode_duration_minutes !== 'number' ||
    !(valueFromFwF.high_demand_mode_duration_minutes > 0)
  )
    return false;

  if (
    !('high_demand_mode_suggestion_enabled' in valueFromFwF) ||
    typeof valueFromFwF.high_demand_mode_suggestion_enabled !== 'boolean'
  )
    return false;

  return true;
};
